<template>
<div>
  <div class="row">
    <div class="col">
       <form v-on:submit.prevent="save">
        <div class="form-group">
          <label for="nome">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="form.nome"
            id="nome"
          />
        </div>

        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="text"
            class="form-control"
            v-model="form.email"
            id="email"
          />
        </div>

        <div class="form-group">
          <label for="telefone">Telefone</label>
          <input
            type="text"
            class="form-control"
            v-model="form.telefone"
            id="telefone"
          />
        </div>

        <div class="form-group">
          <label for="mensagem">Mensagem</label>
          <textarea
            v-model="form.mensagem"
            class="form-control"
            name="mensagem"
            id="mensagem"
            cols="30"
            rows="10">
          </textarea>
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-raised btn-block">Enviar Mensagem</button>
          <router-link to="/" class="btn btn-danger btn-raised btn-block">Voltar</router-link>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Suporte',
  data() {
    return {
      form: {
        nome: '',
        email: '',
        telefone: '',
        mensagem: ''
      }
    };
  },
  methods: {
    save() {
      this.$http.post(`/contato`, this.form).then(res => {
        if (res.data.success) {
          this.$toasted.show(
            'Mensagem enviada com sucesso!',
            this.$custom.success
          );

          this.form = {
            nome: '',
            email: '',
            telefone: '',
            mensagem: ''
          };
        } else {
          this.$toasted.show(
            'Ocorreu um problema ao enviar a mensagem, tente mais tarde!',
            this.$custom.error
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/app/home/Suporte.vue